import { render, staticRenderFns } from "./school.vue?vue&type=template&id=f9d4ca32&scoped=true&"
import script from "./school.vue?vue&type=script&lang=js&"
export * from "./school.vue?vue&type=script&lang=js&"
import style0 from "./school.vue?vue&type=style&index=0&id=f9d4ca32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d4ca32",
  null
  
)

export default component.exports